import { render } from "./SFaceUsedLowerDefaultFooter.vue?vue&type=template&id=37eb94b8&scoped=true"
import script from "./SFaceUsedLowerDefaultFooter.vue?vue&type=script&lang=js"
export * from "./SFaceUsedLowerDefaultFooter.vue?vue&type=script&lang=js"

import "./SFaceUsedLowerDefaultFooter.vue?vue&type=style&index=0&id=37eb94b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37eb94b8"

export default script